import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { BaseService } from 'projects/Autofacets-Core/src/app/services/base.service';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DealerPartSearchObj } from '../../../business-entities/dealer-part-search-object-view-model';
import { DealerPartsListDetails } from '../../../business-entities/dealer-parts-list-details-view-model';
import { PartsListViewModel } from '../../../business-entities/parts-list-view-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { DealerPartsService } from '../../../business-services/dealer-parts.service';
import { RentalCarService } from '../../../business-services/rental-car.service';
import * as Enums from './../../../../../../Autofacets-Core/src/app/utils/enums';


@Component({
  selector: 'app-add-dealer-parts',
  templateUrl: './add-dealer-parts.component.html'
})
export class AddDealerPartsComponent implements OnInit {
  searchObj: DealerPartSearchObj = {
    partId: 0,
    dealerId: ''
  };
  dealerPartDetails: DealerPartsListDetails[];
  addDealerPartsForm: FormGroup;
  dealerList: SelectListItemViewModel[];
  partsList: PartsListViewModel[];
  SelectedDealer: string;
  SelectedParts: string;
  noPartsAvailable: boolean = false;
  unitPrice: string;
  constructor(private formBuilder: FormBuilder,
    private service: RentalCarService,
    private spinner: NgxSpinnerService,
    private cookieservice: CookieService,
    private dealerPartService: DealerPartsService,
    private baseService: BaseService,
    private router: Router,
    private toaster: ToastrService,
    private translate: TranslateService,
    private userService: UserDataService,
    private globalSetting: GlobalSetting,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.getDealerPartSearch(this.searchObj);
    this.dealerList = this.dealerPartService.dealerList;

    this.addDealerPartsForm = this.formBuilder.group({
      dealerName: [null, [Validators.required]],
      partNumber: [null, [Validators.required]],
      convertToPartNumber: [''],
      unitPrice: [''],
      isActive: [true],
      quantity: [null, [Validators.required]]
    });
    if (this.dealerList && this.dealerList.length == 1) {
      this.SelectedDealer = this.dealerList[0].value;
      this.cpf.dealerName.disable();
      this.addDealerPartsForm.get('dealerName').disable();
      this.addDealerPartsForm.get('partNumber').enable();
      this.getDealerPartsList();
    }else{
      this.addDealerPartsForm.get('partNumber').disable();
    }
  }
  async getDealerPartSearch(searchObj: DealerPartSearchObj) {
    this.spinner.show();
    searchObj.languageCode = this.cookieservice.get('userSelectedLanguage')
    await this.dealerPartService.getDealerAndPartSearch(searchObj).then((response:any) => {
      this.dealerPartDetails = response;

    })
    this.spinner.hide();
  }
  get cpf() {
    return this.addDealerPartsForm.controls;
  }

  onBlur(event) {
    this.unitPrice = event.target.value;
  }

  async getDealerPartsList() {
    this.SelectedParts = "";
    if (this.SelectedDealer != null) {
      let dealerMapParts = this.dealerPartDetails.filter(f => f.dealerId == this.SelectedDealer);
      let parts = [];
      for (let value of this.dealerPartService.partsList) {
          if(dealerMapParts.filter(f=>f.partNumber == value.partNumber).length == 0){
            parts.push(value);
          }
      }
      this.partsList = parts;
    }else{
      this.partsList = [];
    }

    if (this.partsList.length == 0) {
      this.noPartsAvailable = true;
      this.addDealerPartsForm.get('partNumber').disable();
    }
    else {
      this.noPartsAvailable = false;
      this.addDealerPartsForm.get('partNumber').enable();
    }
  }
  OnClose() {
    this.activeModal.dismiss('Cross click')
  }

  addDealerParts() {
    this.spinner.show();
    const partNumber = this.addDealerPartsForm.get('partNumber').value;
    const parts = this.partsList.find(x => x.id === partNumber);
    const unitPrice = this.addDealerPartsForm.get('unitPrice').value;
    if (parts && unitPrice > parts.unitPrice) {
      this.addDealerPartsForm.controls.unitPrice.setErrors({ unitPriceFlag: true });
      this.spinner.hide();
    }
    else {
      this.addDealerPartsForm.controls.unitPrice.setErrors(null)
      let viewModel =
      {
        DealerId: this.SelectedDealer.toString(),
        PartId: +this.addDealerPartsForm.get('partNumber').value,
        PartNumber:parts.partNumber,
        ConvertToPartNumber: this.addDealerPartsForm.get('convertToPartNumber').value,
        UnitPrice: +this.globalSetting.getFormattedprice(this.addDealerPartsForm.get('unitPrice').value),
        IsActive: this.addDealerPartsForm.get('isActive').value,
        CreatedBy: '',
        TotalQuantity: +this.addDealerPartsForm.get('quantity').value
      }
      this.dealerPartService.addDealerParts(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          this.activeModal.close({ success: true });
          let successMsg = this.translate.instant("lblPartAdded");
          this.toaster.success(successMsg);
        }
        else if (res.responseCode === Enums.ErrorCodes.RentalCarAlreadyAdded) {
          this.spinner.hide();
          let errorErr = this.translate.instant("lblPartExist");
          this.toaster.warning(errorErr);
        }
      });
      this.spinner.hide();
    }



  }
}
